// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__iu8X9","footerContent":"Footer_footerContent__Zsik1","footerHighlight":"Footer_footerHighlight__dGSrl"};